import illustrationAnanasPastequePlat from "@/assets/images/illustration-ananas-pasteque-plat.svg";
import illustrationVinFromagePoulet from "@/assets/images/illustration-vin-fromage-poulet.svg";
import illustrationAnanasPastequePain from "@/assets/images/illustration-ananas-pasteque-pain.svg";
import illustrationCarotteFromageLait from "@/assets/images/illustration-carotte-fromage-lait.svg";
import { useProductsStore } from "@/store/products";
import { useContextStore } from "@/store/context";
import { useMagasinStore } from "@/store/magasin";
import { useDatalayerStore } from "@/store/datalayer";
import UniversePageCodes from "@/utils/universe-page-codes";
import { useProductDetailsTracking } from "@/mixins/tracking/product-details";

export const usePageUniverse = () => {
  const showMoreDescription = ref(false)
  const pushProductsTitle = ref("")
  const fistPushZoneTitle = ref("")
  const secondPushZoneTitle = ref("")

  const { trackProductPage } = useProductDetailsTracking();

  const { layout } = storeToRefs(useContextStore())
  const { isNational } = storeToRefs(useMagasinStore())
  const { title, description, breadcrumbs, childrenCategories, pushZones, attributes } = storeToRefs(useProductsStore())

  const { setLocation } = useDatalayerStore();

  const breadcrumb = computed(() => {
    return breadcrumbs.value.map((item) => (
      { text: item.title, route: item.slug }
    ))
  })

  const getPushData = (code, position = null) => {
    // recuperer le contenu html des differentes zones de push selon le code et la position
    const pushElement = pushZones.value.find(e => e.code === code && e.position === position)
    if (code === UniversePageCodes.Niv1_2_MEA && position === 1) {
      fistPushZoneTitle.value = pushElement && pushElement.titre !== "null" ? pushElement.titre : ""
    }
    if (code === UniversePageCodes.Niv1_2_MEA_Producteur && position === 1) {
      secondPushZoneTitle.value = pushElement && pushElement.titre !== "null" ? pushElement.titre : ""
    }
    return pushElement !== undefined ? pushElement : {}
  }
  const getPushProducts = (code) => {
    // fonction pour recuperer les produits de push
    const pushElement = pushZones.value.find(e => e.code === code);
    pushProductsTitle.value = pushElement && pushElement.titre !== "null" ? pushElement.titre : ""
    return pushElement ? pushElement.products : []
  }
  const truncatedText = (text, maxlength) => {
    // fonction qui permet de tronquer le texte
    // si on recoit pas la longuer maximale on retourne le texte en entier
    // sinon si la longuer de texte est supérieure a la longueur maximale donné on retourne le texte tronqué avec "..." a la fin
    return maxlength !== 0 ? text.length > maxlength ? `${text.substr(0, maxlength - 1)}...` : text : text
  }
  const showMoreText = () => {
    // fonction qui permet d'afficher  le reste du texte caché
    showMoreDescription.value = !showMoreDescription.value
  }
  const onProductIntersect = (index, pushName) => {
    if (index % 6 === 0) {
      const productsList = getPushProducts(pushName)
      const products = productsList && productsList.length > 0 ? productsList.slice(index - 6, index) : []
      trackProductPage(
        {
          type: trackingCodes.IMPRESSIONDONE,
          products,
          index,
          actionField: "Page univers: push produit"
        })
    }
  }

  const mounted = () => {
    setLocation("listingProduit")
  }

  return {
    showMoreDescription,
    imageCarotteFromageLait: illustrationCarotteFromageLait,
    imageAnanasPastequePain: illustrationAnanasPastequePain,
    imageVinFromagePoulet: illustrationVinFromagePoulet,
    imageAnanasPastequePlat: illustrationAnanasPastequePlat,
    pushProductsTitle,
    fistPushZoneTitle,
    secondPushZoneTitle,
    UniversePageCodes,
    layout,
    isNational,
    title,
    description,
    breadcrumbs,
    childrenCategories,
    pushZones,
    attributes,
    breadcrumb,
    getPushData,
    getPushProducts,
    truncatedText,
    showMoreText,
    mounted,
    onProductIntersect
  }
}